<template>
    <div>
        <ui-icon-button ref="tagButton" @click="loadTags" has-dropdown icon="sell" type="secondary" style="vertical-align: middle;" tooltip="Tag">
            <div slot="dropdown">
                <div class="container-fluid" style="padding: 1rem 1rem 0.5rem;">
                    <form @submit.prevent="tagSelection">
                    <div v-if="loaded">
                        <ui-autocomplete @select="tagSelection"
                                         @keypress.enter="tagSelection"
                                         placeholder="Tag name"
                                         v-model="tag"
                                         :suggestions="existingTags"
                                         help="Press enter to submit"
                        ></ui-autocomplete>
                    </div>
                    <ui-progress-circular v-show="!loaded" v-else></ui-progress-circular>
                    </form>
                </div>
            </div>
        </ui-icon-button>
    </div>
</template>

<script>
    export default {
        props: {
            conversations: {
              type: Array,
              required: true
            },
        },
        data() {
            return {
                loaded: false,
                tag: ''
            }
        },
        computed: {
            existingTags() {
                return this.$store.getters['inbox/tags/tags'].map(r => {
                    return r.name
                })
            }
        },
        methods: {
            loadTags() {
                this.loaded = false

                this.$store.dispatch('inbox/tags/load').then(r => {
                    this.loaded = true
                })
            },
            tagSelection() {
                let promises = []

                let tagObj = {name: this.tag}

                this.$refs.tagButton.closeDropdown()
                this.$refs.tagButton.$el.blur()

                for (let i in this.conversations) {
                    promises.push(this.$store.dispatch(
                        'inbox/conversations/tag', {
                            conversation_id: this.conversations[i].id, tag: tagObj
                        }
                    ))
                }

                Promise.all(promises).then(() => {
                    this.$emit('changed')
                    this.tag = ''
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-fluid {
        width: 270px;

        .row {
            border-top: 1px solid #eee;
            padding-top: .5rem;
            padding-bottom: .5rem;
            cursor: pointer;

            &:hover { background: #f8f8f8; }
        }

        .material-icons { vertical-align: middle; }
    }
</style>